import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import { UsageAttitudeAboutStyles } from './styles';
import aboutImg from '../../../assets/images/usageAttitude/about.png';
import aboutItem1 from '../../../assets/images/usageAttitude/about-item-1.png';
import aboutItem2 from '../../../assets/images/usageAttitude/about-item-2.png';
import aboutItem3 from '../../../assets/images/usageAttitude/about-item-3.png';
import aboutItem4 from '../../../assets/images/usageAttitude/about-item-4.png';

export const UsageAttitudeAbout = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  return (
    <UsageAttitudeAboutStyles>
      <div className="container">
        <h5>
          {getTranslationsByLangOrEng(interfaceLanguage, 'usage_attitude_4')}
        </h5>
        <div className="content">
          <img src={aboutImg} alt="" />
          <div className="cards">
            <div className="cards-item">
              <div className="cards-img">
                <img src={aboutItem1} alt="" />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: getTranslationsByLangOrEng(
                    interfaceLanguage,
                    'usage_attitude_5',
                  ),
                }}
              />
            </div>
            <div className="cards-item">
              <div className="cards-img">
                <img src={aboutItem2} alt="" />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: getTranslationsByLangOrEng(
                    interfaceLanguage,
                    'usage_attitude_6',
                  ),
                }}
              />
            </div>
            <div className="cards-item">
              <div className="cards-img">
                <img src={aboutItem3} alt="" />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: getTranslationsByLangOrEng(
                    interfaceLanguage,
                    'usage_attitude_7',
                  ),
                }}
              />
            </div>
            <div className="cards-item">
              <div className="cards-img">
                <img src={aboutItem4} alt="" />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: getTranslationsByLangOrEng(
                    interfaceLanguage,
                    'usage_attitude_8',
                  ),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </UsageAttitudeAboutStyles>
  );
};
